import { useTranslation } from 'react-i18next';
import { Pressable, ScrollView, Text, TextInput, View } from 'react-native';
import { Header } from '../component/Header';
import User from '../object/User';
import { FONT_BOLD, getColor } from '../utils/theme';
import { height, width } from '../utils/utils';
import { CloseAllButton } from '../component/CloseAllButton';
import React, { useEffect, useRef } from 'react';

interface IExposantModalProps {
    navigation: any;
}

export const ExposantModal = (props: IExposantModalProps) => {
    const { t } = useTranslation();

    const stand = (props as any).route.params.stand;
    const textInput = useRef(null);
    useEffect(() => {
        setTimeout(() => {
            if (textInput.current) {
                textInput.current.click();
            }
        }, 400); // Reduced from 1000 to a shorter delay to test
    }, []);

    return (
        <ScrollView>
            <View
                style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: getColor('background'),
                }}
            >
                <Header
                    modal={true}
                    title={t('exposant')}
                    line={1}
                    logo={User._instance.getEvent()?.logo.get() ?? ''}
                    backButton={true}
                    navigation={props.navigation}
                    after={
                        <View
                            style={{
                                height: 10,
                            }}
                        ></View>
                    }
                >
                    <View
                        style={{
                            width: width(),
                            zIndex: 500,
                            flex: 1,
                        }}
                    >
                        <View
                            style={{
                                marginHorizontal: 20,
                                marginBottom: 10,
                            }}
                        >
                            <Pressable
                                key={stand.getJTOIdentifier()}
                                style={{
                                    borderRadius: 25,
                                    marginBottom: 20,
                                    backgroundColor: 'white',
                                    shadowColor: getColor('hint'),
                                    shadowOffset: {
                                        width: 0,
                                        height: 2,
                                    },
                                    shadowOpacity: 0.2,
                                    shadowRadius: 3.84,
                                    elevation: 5,
                                    paddingTop: 10,
                                }}
                            >
                                <View
                                    style={{
                                        borderRadius: 24,
                                        overflow: 'hidden',
                                    }}
                                >
                                    <View
                                        style={{
                                            backgroundColor:
                                                getColor('primary'),
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: 20,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Text
                                            style={{
                                                marginLeft: 10,
                                                fontSize: 20,
                                                fontFamily: FONT_BOLD,
                                                color: 'white',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {t('stand_exposant')} :{' '}
                                            {stand.exposant.raisonSociale2 !==
                                            ''
                                                ? stand.exposant
                                                      .raisonSociale1 +
                                                  '\n' +
                                                  stand.exposant.raisonSociale2
                                                : stand.exposant.raisonSociale1}
                                        </Text>
                                        <Text
                                            style={{
                                                marginLeft: 10,
                                                fontSize: 20,
                                                fontFamily: FONT_BOLD,
                                                color: 'white',
                                            }}
                                        >
                                            {t('stand_hall')} : {stand.hall}
                                        </Text>
                                        <Text
                                            style={{
                                                marginLeft: 10,
                                                fontSize: 20,
                                                fontFamily: FONT_BOLD,
                                                color: 'white',
                                            }}
                                        >
                                            {t('stand_number')} : {stand.stand}
                                        </Text>
                                    </View>
                                </View>
                            </Pressable>
                        </View>
                        <View
                            style={{
                                height: 60,
                            }}
                        ></View>
                        <View
                            style={{
                                height: 60,
                            }}
                        ></View>
                        <View
                            style={{
                                height: 60,
                            }}
                        ></View>
                    </View>
                </Header>

                <CloseAllButton
                    onPress={() => {
                        props.navigation.popToTop();
                    }}
                />
            </View>
        </ScrollView>
    );
};
